export const GI_UPDATE_STATE = "GI_UPDATE_STATE"
export const GI_MORE_INTENTS_LOADED = "GI_MORE_INTENTS_LOADED"
export const GI_INTENT_CREATED = "GI_INTENT_CREATED"
export const GI_INTENT_UPDATED = "GI_INTENT_UPDATED"
export const GI_INTENT_DELETED = "GI_INTENT_DELETED"
